import { ChangeDetectorRef, Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from "@angular/common";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { CoreLogService } from '../../services/log.service';
import { WebShopService } from '../../services/webShop.service';
import { Observable, Subscription } from 'rxjs';
import { IRemoteOrderModeSelector as IRemoteOrderModeSelector } from './remoteOrderModeSelector.facade';
import { RemoteOrderModeSelectorService } from './remoteOrderModeSelector.service';
import Utils from '../../shared/utils';
import { trigger, transition, query, style, stagger, animate } from '@angular/animations';
import { WebShopMode } from '../../shared/contentTypes';

@Component({
  selector: 'remoteOrderModeSelector',
  templateUrl: './remoteOrderModeSelector.component.html',
  styleUrls: ['./remoteOrderModeSelector.component.scss'],
  providers: [RemoteOrderModeSelectorService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [trigger("serviceButtonEntering", [
    transition("false => true", [
      query(".animate", [
        style({ transform: "scale(0)" }),
        stagger(100, [
          animate("400ms ease-out", style({ transform: "scale(1.1)" })),
          animate("100ms ease-in-out", style({ transform: "scale(1)" }))
        ])
      ])
    ])
  ])]
})

export class RemoteOrderModeSelector implements OnInit, OnDestroy {
  public isSmallView: boolean = false;
  public loadAnimation: boolean = false;
  private _viewTypeSubscription: Subscription;

  public remoteOrderModeSelector$: Observable<IRemoteOrderModeSelector>;
  constructor(private _remoteOrderModeSelectorService: RemoteOrderModeSelectorService
    , private _location: Location
    , private _router: Router
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _mainnavService: MainnavService
    , private _webShopService: WebShopService
  ) { }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("remoteOrderModeSelector.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.loadAnimation = true;
    me.onViewTypeChanges(me._mainnavService.viewType);
    me._viewTypeSubscription = me._mainnavService.observeViewTypeChanges.subscribe((viewType) => {
      me.onViewTypeChanges(viewType);
      me.PushChanges();
    });
    me._remoteOrderModeSelectorService.loadData();
    me.remoteOrderModeSelector$ = me._remoteOrderModeSelectorService.remoteOrderModeSelector$
    me.PushChanges();
  }

  /** selected location ID */
  public get locationID() {
    const me = this;
    return me._webShopService.locationID;
  }

  /** single order: default order mode */
  public async navigateToSingleOrder(): Promise<void> {
    const me = this;
    // aktuelle service mode muss auf einzel service mode gesetzt werden
    let hasError = false;
    switch (me._webShopService.getServiceMode()) {
      case WebShopMode.DeliveryGroup:
        hasError = await me._webShopService.changeServiceMode(WebShopMode.Delivery) === null;
        break;
      case WebShopMode.PickupGroup:
        hasError = await me._webShopService.changeServiceMode(WebShopMode.TakeAway) === null;
        break;
      default:
        // keep service mode
        break;
    }
    if (hasError) {
      const serviceMode = me._webShopService.getServiceMode();
      if (serviceMode === WebShopMode.Delivery || serviceMode === WebShopMode.TakeAway) {
        me._router.navigate(["/orderTimeSelector"]);
      } else {
        me._router.navigate(["/remoteOrderGroupDefineName"]);
      }
    } else {
      me._router.navigate(["/orderTimeSelector"]);
    }
  }

  /**
   * Checks if the provided content is not null or empty.
   * @param content - The string to check.
   * @returns True if the content is not null or empty, otherwise false.
   */
  public hasContent(content: string) {
    return !Utils.IsNullOrEmpty(content);
  }

  /**
   * Navigates to the group order page based on the current service mode.
   * @returns  Resolves when navigation is complete.
   */
  public async navigationToGroupOrder(): Promise<void> {
    const me = this;
    // aktuelle service mode muss auf gruppen service mode gesetzt werden
    let hasError = false;
    switch (me._webShopService.getServiceMode()) {
      case WebShopMode.Delivery:
        hasError = await me._webShopService.changeServiceMode(WebShopMode.DeliveryGroup) === null;
        break;
      case WebShopMode.TakeAway:
        hasError = await me._webShopService.changeServiceMode(WebShopMode.PickupGroup) === null;
        break;
      default:
        // keep service mode
        break;
    }
    if (hasError) {
      const serviceMode = me._webShopService.getServiceMode();
      if (serviceMode === WebShopMode.Delivery || serviceMode === WebShopMode.TakeAway) {
        me._router.navigate(["/orderTimeSelector"]);
      } else {
        me._router.navigate(["/remoteOrderGroupDefineName"]);
      }
    } else {
      me._router.navigate(["/remoteOrderGroupDefineName"]);
    }

  }

  /** navigate back by swipe from left to right */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView === true) {
      me.navigateBack();
    }
  }

  /** navigate back */
  public navigateBack(): void {
    this._location.back();
  }

  /**
 * Updates the view type state based on the provided view type.
 * Sets isSmallView to true if the view type is Small, otherwise sets it to false.
 * @param viewType - The current view type.
 */
  private onViewTypeChanges(viewType: ViewType) {
    const me = this;
    me.isSmallView = (viewType === ViewType.Small);
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._viewTypeSubscription) {
      me._viewTypeSubscription.unsubscribe();
    }
  }
}




